import React from 'react'

import TherapistSpecializationBadge from '@/legacy-src/components/TherapistSpecializationBadge'

import type { TranslatorType } from '../types/FunctionTypes'
import type { SpecializationOptionsType } from '../types/TherapistStateType'

type SpecializationMapperPropTypes = {
  majorSpecializations: number[]
  minorSpecializations?: number[]
  t: TranslatorType
  specializationOptions: SpecializationOptionsType
}

const Tags: React.FC<{ specializations: number[]; specializationOptions: SpecializationOptionsType }> = ({
  specializations,
  specializationOptions,
}) => {
  return (
    <div className="flex flex-wrap gap-3">
      {specializations.map((specialization) => (
        <TherapistSpecializationBadge key={specialization} className="bg-white">
          {specializationOptions[specialization]}
        </TherapistSpecializationBadge>
      ))}
    </div>
  )
}

const SpecializationMapper = (props: SpecializationMapperPropTypes) => {
  const { majorSpecializations, minorSpecializations = [], specializationOptions, t } = props
  const hasMajor = majorSpecializations.length > 0
  const hasMinor = minorSpecializations.length > 0

  if (!hasMajor && !hasMinor) {
    return null
  }

  return (
    <div>
      {hasMajor ? (
        <div className="mb-8">
          <h3>{t('therapistProfile.majorSpecializations')}</h3>
          <Tags specializations={majorSpecializations} specializationOptions={specializationOptions} />
        </div>
      ) : null}
      {hasMinor ? (
        <div className="mb-8">
          <h3>{t('therapistProfile.minorSpecializations')}</h3>
          <Tags specializations={minorSpecializations} specializationOptions={specializationOptions} />
        </div>
      ) : null}
    </div>
  )
}

export default SpecializationMapper
